module.exports = __webpack_public_path__ + "img/icon12.f89baa66.png";